<template>
    <div class="social-container">
        <a class="numbers-card-numbers-card" v-for="item of items" :href="item.Link">
            <api-image :image="item.Icon" :title="item.Name" class="numbers-card-image"/>
            <span class="numbers-card-text">{{ item.Name }}</span>
        </a>
    </div>
</template>

<script>
    import api_fetch from "../api_fetch";

    export default {
        data() {
            return {
                items: []
            }
        },
        created() {
            api_fetch('api/socials').then((data) => {
                data.forEach(item => {
                    this.items.push(item.attributes);
                });
            });
        }
    }
</script>

<style scoped>
    .social-container {
        display: flex;
        align-self: center;
        align-items: center;
        justify-content: center;
    }

    .numbers-card-numbers-card {
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        margin-left: var(--dl-space-space-twounits);
        margin-right: var(--dl-space-space-twounits);
        flex-direction: column;
    }

    .numbers-card-image {
        width: 45px;
        height: 45px;
        object-fit: cover;
        margin-bottom: var(--dl-space-space-unit);
        filter: brightness(0) invert(1);
    }

    .numbers-card-text {
        color: rgba(255, 255, 255, 0.8);
        font-style: normal;
        font-weight: 500;
    }
</style>
